<template>
    <div class="detail-module">
        <div class="box">
            <div class="select-box  flex-col flex-y-center">
                <div class="date-box  flex-row  flex-between">
                    <div class="date flex-y-center flex">
                        <div class="arrow-box" @click="handleCalendar('prev')">
                            <div class="arrow-l"></div>
                        </div>
                        <div>{{ year }}年{{ month }}月</div>
                        <div class="arrow-box" @click="handleCalendar('next')">
                            <div class="arrow-r"></div>
                        </div>
                    </div>
                </div>
            </div>
            <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
                <div class="detail-box">
                    <div class="table-tab  flex flex-x-center flex-between">
                        <div :class="`tab-item ${workNoStatus == 1 ? 'active' : ''}`" @click="clickTab(1)">
                            待解决({{ orderData.waitTotal }})
                        </div>
                        <div :class="`tab-item item-text ${workNoStatus == 3 ? 'active' : ''}`" @click="clickTab(3)">
                            已解决({{ orderData.solveTotal }})
                        </div>
                    </div>
                    <div v-if="orderList.length != 0">
                        <div class="customer-list" v-for="(item, index) in orderList" :key="index" @click="toDetail(item.workNoTypeId, item.storeNo, item.guid, item.workNo)">
                            <div class="flex-row cust-info flex-y-center">
                                <img class="head-img" referrerpolicy="no-referrer" :src="item.avatar ? item.avatar : 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" alt="" />
                                <div class="customer-info flex-1 flex-col flex-start">
                                    <div class="flex flex-y-center flex-between">
                                        <div class="cust-name" v-if="item.sourceType != 96">{{ item.customerName }}</div>
                                        <div class="flex-1" v-if="item.sourceType != 96 && item.cardLevel">
                                            <img class="card-img" referrerpolicy="no-referrer" :src="item.cardLevel" alt="" />
                                        </div>
                                        <div class="cust-name" v-else-if="item.sourceType == 96">工单来源：{{ item.sourceTypeStr }}</div>
                                        <div class="flex flex-start flex-y-center">
                                            <div :class="['cust-name', item.status == 1 ? 'red' : '']">{{ item.statusStr }}</div>
                                            <!-- <div class="cust-name" v-if="item.status == 2">已提交</div>
                                            <div class="cust-name" v-if="item.status == 3">已解决</div> -->
                                            <img class="arrow" referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" alt="" />
                                        </div>

                                    </div>
                                    <!-- <div class="flex flex-y-center flex-between mt-10">
                                        <div class="txt">{{item.createTime}}</div>
                                    </div> -->
                                </div>

                            </div>
                            <div class="customer-remark">
                                <div class="remark-item">
                                    工单号：{{ item.workNo }}
                                </div>
                                <div class="remark-item">
                                    创建时间：{{ item.createTime }}
                                </div>
                                <div v-if="workNoStatus == 3">
                                    解决时间：{{ item.solveTime }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="flex flex-col flex-y-center">
                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png" class="empty-icon" alt="" />
                        <div class="empty-txt">暂无</div>
                    </div>
                </div>

            </van-pull-refresh>
        </div>

    </div>
</template>
<script>
    import request from "@/utils/request";
    import { Toast } from 'vant'
    import { keepAliveAfterHandler } from "@/router/router";

    export default {
        name: "repairOrderList",
        components: {
        },
        data() {
            return {
                refreshing: false,
                orderData: {},//数据
                orderList: [],//列表
                workNoStatus: 1, //tab1处理中 3已关闭
                workNoType: 1,//工单类型 3 投诉 1 反馈/建议
                year: "",
                month: "",
            };
        },
        computed: {
        },
        beforeRouteLeave(to, from, next) {
            keepAliveAfterHandler.call(this, to, from)
            next()
        },
        mounted() {
            this.workNoType = this.$route.query.workNoType
            this.year = this.$route.query.year
            this.month = this.$route.query.month
            if (this.workNoType == 1) {
                document.title = '反馈工单'
            } else if (this.workNoType == 3) {
                document.title = '投诉工单'
            } else if (this.workNoType == 4) {
                document.title = '满意度工单'
            }
            this.getOrderList();
        },
        methods: {

            // 获取详情
            getOrderList() {
                request({
                    url: `/work/workNoList?workNoStatus=${this.workNoStatus}&workNoType=${this.workNoType}
                &newDate=${this.year}-${this.month}`,
                    method: "get",
                })
                    .then((res) => {
                        this.orderData = res.data
                        this.orderList = res.data.workOrderDTOS
                    }).catch((error) => {
                        this.finished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.loading = false;
                    });
            },
            // tab切换
            clickTab(tabIndex) {
                this.workNoStatus = tabIndex
                this.getOrderList();
            },
            onRefresh() {
                // // 将 loading 设置为 true，表示处于加载状态
                this.refreshing = false;
                this.getOrderList();
            },
            // 去详情
            toDetail(workNoTypeId, storeNo, guid, workNo) {
                if (parseInt(this.workNoType) == 4) {
                    this.$router.push({ name: 'VocWorkOrder', query: { workOrderNo: workNo } });
                } else {
                    this.$router.push({ name: 'repairOrderDetail', query: { workNoTypeId, storeNo, guid, workNo } });
                }
            },
            // 切换月份
            handleCalendar(handle) {
                const year = this.year;
                const month = this.month;
                this.orderList = [];
                if (handle === "prev") {
                    let newMonth = month - 1;
                    let newYear = year;
                    if (newMonth < 1) {
                        newYear = year - 1;
                        newMonth = 12;
                    }
                    this.year = newYear
                    this.month = newMonth
                    this.getOrderList();

                } else {
                    let newMonth = month + 1;
                    let newYear = year;
                    if (newMonth > 12) {
                        newYear = year + 1;
                        newMonth = 1;
                    }
                    this.year = newYear
                    this.month = newMonth
                    this.getOrderList();

                }
            },
        },
    };
</script>
<style lang="less" scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    .mr-30 {
        margin-right: 30px;
    }

    .mt-10 {
        margin-top: 10px;
    }

    .detail-module {
        background-color: #fff;
        height: 100%;
        overflow-y: auto;
    }

    .box {
        background-color: #f9fafc;
    }

    .select-box {
        background-color: #fff;
        margin-bottom: 20px;
        padding: 30px 34px;

        .date {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin: -6px 0;
            font-size: 30px;
            color: #35434c;
        }

        .arrow-l {
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-right: 10px solid #35434c;
            border-bottom: 10px solid transparent;
            margin-right: 30px;
        }

        .arrow-r {
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-left: 10px solid #35434c;
            border-bottom: 10px solid transparent;
            margin-left: 30px;
        }
    }

    .table-tab {
        width: 690px;
        height: 100%;
        display: flex;
        padding-bottom: 20px;
        border-bottom: 1px solid #d7d7d7;
        margin-bottom: 30px;
    }

    .tab-item {
        width: 250px;
        height: 42px;
        font-size: 30px;
        font-weight: 400;
        color: #a0acb5;
        text-align: center;
        position: relative;
    }

    .item-text {
        margin-left: 102px;
    }

    .tab-item.active {
        color: #35434c;
        font-weight: bold;
    }

    .tab-item.active::after {
        position: absolute;
        bottom: -20px;
        content: "";
        width: 110px;
        height: 6px;
        border-radius: 3px;
        background: #37dbe0;
        left: 50%;
        transform: translateX(-50%);
    }

    .detail-box {
        width: 100%;
        min-height: calc(100vh - 142px);
        background: #ffffff;
        border-radius: 20px 20px 0 0;
        padding: 30px 30px;

        .detail-item {
            width: 690px;
            background: #ffffff;
            box-shadow: 0px 6px 26px 0px rgba(2, 2, 2, 0.08);
            border-radius: 20px;
            margin-bottom: 30px;
            padding: 30px 20px;
        }
    }

    .radio-box {
        margin-right: 20px;

        :deep(.van-checkbox) {
            margin-bottom: 0 !important;
        }
    }

    .detail-title {
        font-size: 28px;
        color: #35434c;
    }

    .info-remain {
        height: 70px;
        background: #e9f2ff;
        border-radius: 4px;
        color: #a0acb5;
        font-size: 28px;
        padding: 12px 20px;
        margin-bottom: 29px;

        .head-icon {
            width: 46px;
            height: 46px;
            border-radius: 50%;
            margin-right: 20px;
        }

        .head-icon-m {
            margin-left: -18px;
        }
    }

    .customer-list {
        width: 690px;
        min-height: 150px;
        background: #fafafe;
        border-radius: 20px;
        padding: 30px 0;
        margin-bottom: 20px;

        .head-img {
            width: 90px;
            height: 90px;
            border-radius: 45px;
            margin-right: 20px;
            margin-left: 20px;
        }

        .cust-name {
            min-width: 90px;
            margin-right: 10px;
            font-size: 30px;
            font-weight: 400;
            color: #35434c;
        }

        .cust-name.red {
            color: #f65252;
        }

        .card-img {
            width: 90px;
            height: 34px;
        }

        .arrow {
            width: 15px;
            height: 26px;
            margin-right: 30px;
            margin-left: 20px;
        }

        .txt {
            font-size: 26px;
            font-weight: 400;
            color: #66757f;
        }

        .customer-remark {
            border-top: 1px solid #d7d7d7;
            padding: 30px 20px 0 20px;
            margin-top: 30px;
            font-size: 26px;
            font-weight: 400;
            color: #66757f;
            line-height: 37px;
        }

        .remark-item {
            margin-bottom: 15px;
        }
    }

    .exclusive {
        width: 84px;
        height: 40px;
        font-size: 28px;
        color: #a0acb5;
        line-height: 40px;
        margin: 30px 0 0 20px;
    }

    .exclusive-name {
        min-width: 84px;
        height: 40px;
        font-size: 28px;
        color: #35434c;
        line-height: 40px;
        margin-top: 30px;
    }

    .loss {
        width: 140px;
        height: 40px;
        font-size: 28px;
        color: #a0acb5;
        line-height: 40px;
        margin: 30px 0 0 84px;
    }

    .loss-reasons {
        height: 40px;
        font-size: 28px;
        color: #35434c;
        line-height: 40px;
        margin-top: 30px;
    }

    .bottom-box {
        height: 100px;
        border-top: 1px solid #d7d7d7;
        background-color: #fff;
        border-radius: 0 0 20px 20px;
        font-size: 28px;
        color: #35434c;
        padding: 20px 30px;

        .clock {
            font-size: 32px;
            margin-right: 20px;
        }

        .time {
            width: 344px;
            text-align: right;
        }
    }

    .empty-icon {
        width: 280px;
        height: 280px;
        margin-top: 179px;
    }

    .empty-txt {
        font-size: 30px;
        color: #a0acb5;
    }

    :deep(.van-checkbox__icon .van-icon) {
        width: 32px;
        height: 32px;
        line-height: 32px;
    }

    :deep(.van-checkbox__icon--checked .van-icon) {
        background-color: #fff;
        border-color: #a0acb5;
        color: #a0acb5;
    }
</style>